import { LoadingSpinner } from '@/components/UI/Common/Admin/LoadingSpinner';
import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import { ROUTES } from '@/config/routes';
import { useDeleteOne, useGetOne, useUpdateOne } from '@/queries/admin';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { getBackUrl } from '@/utils/helpers';
import { Form, type FormData } from './Form';

export const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);
  const { data: template } = useGetOne('chat-templates', id!, {
    enabled: Boolean(id) && !isDeleting,
  });
  const { mutateAsync: updateTemplate } = useUpdateOne('chat-templates');
  const { mutateAsync: deleteTemplate } = useDeleteOne('chat-templates');
  const [formData, setFormData] = useState<Partial<FormData> | null>(null);

  useEffect(() => {
    if (!template) return;
    setFormData({
      systemName: template.systemName,
      title: template.title,
      sort: template.sort,
      avatar: {
        url: template.upload?.path ? `${getBackUrl()}/uploads/${template.upload.path}` : '',
        rawFile: null,
      },
    });
  }, [template]);

  const onSubmit = async (data: FormData) => {
    try {
      await updateTemplate({
        id: id!,
        data: {
          ...data,
        },
      });

      toast.success('Шаблон чата успешно обновлён');
      navigate(ROUTES.ADMIN.CHATS_TEMPLATES);
    } catch (error) {
      console.error('Error updating chat template:', error);
      toast.error('Произошла ошибка при обновлении шаблона чата');
    }
  };

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await deleteTemplate({ id: id! });
      toast.success('Шаблон чата успешно удалён');
      navigate(ROUTES.ADMIN.CHATS_TEMPLATES);
    } catch (error) {
      setIsDeleting(false);
      console.error('Error deleting chat template:', error);
      toast.error('Произошла ошибка при удалении шаблона чата');
    }
  };

  if (!formData) return <LoadingSpinner className="mt-6" text="Загрузка..." />;

  return (
    <PageLayout
      breadcrumbs={[
        { label: 'Шаблоны чатов', href: ROUTES.ADMIN.CHATS_TEMPLATES },
        { label: 'Редактирование', href: '' },
      ]}
    >
      <Form onDelete={handleDelete} onSubmit={onSubmit} formData={formData} />
    </PageLayout>
  );
};
